import { publishGa4Events } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import Link from 'next/link';
import React from 'react';

import { useCitySelectedContext } from '../../../../contexts/city-context/CityContext';
import { EnterpriseHomeSection } from '../../domain/entities/HomeContentEntity';
import { ENTERPRISE_CTA_CLICK_B } from '../../domain/store/HomeStoreEn';

import styles from '../styles/EnterpriseGrowthCardB.module.scss';

import EnterpriseTextCmp from './EnterpriseTextCmp';

interface EnterpriseGrowthCardCmpProps {
  section_data: EnterpriseHomeSection;
}

function EnterpriseGrowthCardCmp({
  section_data,
}: EnterpriseGrowthCardCmpProps): React.ReactElement | null {
  const citySelectedContext = useCitySelectedContext();

  if (section_data.content.length === 0) return null;

  const ctaEventHandler = (): void => {
    publishGa4Events(citySelectedContext.category, ENTERPRISE_CTA_CLICK_B);
  };

  return (
    <div className={styles['wrapper']}>
      <div className={styles['enterprise-container']}>
        <EnterpriseTextCmp
          class_name={styles['card-title']}
          text_content={section_data.section_title}
        />
        <EnterpriseTextCmp
          class_name={styles['subtitle-description']}
          text_content={section_data.content}
        />
        <Link
          href={section_data.cta.href}
          className={styles['card-cta']}
          onClick={ctaEventHandler}
        >
          {section_data.cta.text}
        </Link>
      </div>
    </div>
  );
}

export default EnterpriseGrowthCardCmp;
